import * as React from 'react';
import cn from 'classnames';

import { Venues } from '@weddingspot/ws-api-client';

import RecommendedVenues from '../venue-recommendations';
import Panel from '../panel';
import SubHeader from '../sub-header';
import { SubHeaderTypes } from '@weddingspot/ws-core-components';
import * as urls from '../../urls';

const styles = require('./unlisted-venue-page.scss');

export interface Props {
    venueName: string;
    recommendations: Venues.VenueRecommendation[];
    recommendationsLoadSucceeded: boolean | undefined;
    userIsAuthed: boolean;
    market: string;
    region: string;
}

export class UnlistedVenuePage extends React.Component<Props> {
    public render() {
        return (
            <div className={styles.wrapper}>
                <div className={styles.hiddenMobile}>
                    <SubHeader headerType={SubHeaderTypes.venueProfile} />
                </div>
                <div className={styles.mainContent}>
                    <div className={styles.panelContainer}>
                        {
                            <Panel>
                                <div className={styles.headline}>
                                    Sorry, <b>{this.props.venueName}</b> is not available, but let's get you back on track!
                                    <br />
                                    We've found some nearby venues you'll love...
                                </div>
                                <RecommendedVenues
                                    recommendations={this.props.recommendations}
                                    recommendationsLoadSucceeded={this.props.recommendationsLoadSucceeded}
                                    onRecommendationClick={() => {}}
                                    renderRdv={false}
                                    hideHeadline={true}
                                />
                                <div className={styles.buttonContainer}>
                                    <button
                                        className={cn('nx-button', styles.ctaButton)}
                                        onClick={() => {
                                            window.location.href = urls.getMarketAndRegionURL(this.props.market, this.props.region);
                                        }}
                                    >
                                        See more
                                    </button>
                                </div>
                            </Panel>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default UnlistedVenuePage;
